import React, { useState, useEffect } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { get } from '../../helpers/api_helper';
import DashboardMetricCard from './metric-card';

function UnshippedMetric(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 2000,
  };

  const { t } = props;
  const [data, setData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const d = await get(`/api/orders/report/unshipped?offset=${props.offset}`);

        setData(d);
      } catch (error) {
        toastr.error(t('Error loading unshipped data'));
      }
    };

    fetchData();
  }, [props.offset]);

  const total = data?.total || 0;
  const shipped = data?.shipped || 0;
  const shippedPercent = total > 0 ? Math.round((shipped / total) * 100) : 0;

  return (
    <DashboardMetricCard
      accent="#4f46e5"
      eyebrow={t('Dispatch')}
      title={t('Shipping Progress')}
      icon="bx bx-send"
      percentage={shippedPercent}
      summary={t('{{count}} shipped today', { count: shipped })}
      details={[
        { label: t('Orders To Ship'), value: total - shipped },
        { label: t('Shipped Today'), value: shipped },
        { label: t('Shipping Queue'), value: total },
      ]}
    />
  );
}

UnshippedMetric.defaultProps = {
  offset: 0,
  t: (x) => (x),
};

UnshippedMetric.propTypes = {
  offset: PropTypes.number,
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(UnshippedMetric));
